'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
    ? function (obj) {
        return typeof obj;
    }
    : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype
            ? "symbol"
            : typeof obj;
    };

// ;(function (global, undefined) {
var CON = {
    _token: $
        .jStorage
        .get("localToken"),
    queryObj: {
        page: 1,
        pageSize: 10,
        status: 0
    },
    pageInfo: null,
    statusMap: {
        0: {
            page: 1,
            status: 0
        },
        1: {
            page: 1,
            status: 1
        },
        2: {
            page: 1,
            status: -1
        }
    },
    lastTims: 0,
    currentData: null,
    currentTab: 0,
    currentDom: null
};

CON.init = function () {
    // this.getCommittalByStatus(this.queryObj, this.renderList);
    this.tabEvent();
    this.editEvent();
    this.jumpToKnow();
    UTL.reachBottom(CON.reachBottomCb);
};

CON.tabEvent = function () {
    $('#tabs')
        .on('click', 'a', function () {
            var index = $(this).index();
            CON.changeTab(index);
        });
};

CON.editEvent = function () {
    $('#listDom')
        .on('click', ' li .handle-delete', function () {
            var data = $(this).data();
            var dataObj = data.info;
            CON.currentData = dataObj;
            CON.currentDom = $(this).parentsUntil('ul');
            CON.travelForm('fillForm', dataObj);
            $("#taskModal").modal("show");
        });

    $('#publishTask').on('click', function () {
        var query = CON.travelForm('getForm');
        CON.currentData = $.extend(CON.currentData, query);
        CON.updateCommittalItem(query, CON.renderItem);
        $("#taskModal").modal("hide");
    });
};

CON.jumpToKnow = function () {
    $('#jumpDom')
        .on('click', function () {
            location.href = Pc_Url + 'membership_plan';
        });
};

CON.travelForm = function (_type, currentData) {
    if (typeof _type != 'string') {
        throw new TypeError("参数一必须为字符串类型，'getForm'或'fillForm'");
    }
    var $inputArr = $('#taskModal .content .input-dom');
    var formObj = {};
    $inputArr.each(function (index, input) {
        var $curDom = $(input);
        var curKey = $curDom.data('id');
        if (_type == 'getForm') {
            formObj[curKey] = $(input).val();
        } else {
            var curVal = currentData[curKey];
            $(input).val(curVal);
        }
    });
    return formObj;
};

CON.onShow = function () {
    $('#tabs .tab')
        .eq(0)
        .click();
};

CON.getCommittalByStatus = function (query, cb, bClear) {
    bClear = bClear || false;
    showLoadingGif();
    $.ajax({
        url: v1url + PAY.api.getCommittal,
        type: "GET",
        data: query,
        headers: {
            token: CON._token
        },
        dataType: "json",
        success: function success(data) {
            if (data.code == 1000) {
                var data = data.data;
                var list = data.items;
                CON.lastTimes = data.left_committal_times;
                CON.showMessage(query.status, CON.lastTimes);
                CON.pageInfo = data.page;
                cb && cb(list, bClear);
                closeLoadingGif();
            } else if (data.code == -1) {
                UTL.showPCLoginForm();
            } else if (data.code == 1006) {
                $("#payModal").modal('show');
            }
        },
        error: function error() {}
    });
};

CON.updateCommittalItem = function (query, cb) {
    $.ajax({
        url: v1url + PAY.api.editCommittal,
        type: "POST",
        data: query,
        headers: {
            token: CON._token
        },
        dataType: "json",
        success: function success(data) {
            if (data.code === 1000) {
                var data = data.data;
                toastr.success('修改成功！');
                cb && cb(CON.currentDom, CON.currentData);
            } else if (data.code == -1) {
                UTL.showPCLoginForm();
            } else {
                toastr.error(data.message);
            }
        },
        error: function error() {}
    });
};

CON.reachBottomCb = function () {
    var $isShow = $('#consignationDisplay').hasClass('be-hide');
    if (!CON.pageInfo || $isShow) 
        return;
    if (CON.queryObj.page >= CON.pageInfo.pages && CON.pageInfo.count > 0) {
        $('.bottom-line').slideDown();
        return;
    }
    CON.queryObj.page++;
    CON.getCommittalByStatus(CON.queryObj, CON.renderList);
};

CON.changeTab = function (index) {
    var $tabs = $('#tabs .tab');
    var $colHeader = $('#handle-status .col-title-box');
    $tabs.removeClass('active');
    $tabs
        .eq(index)
        .addClass('active');
    $colHeader.removeClass('active');
    $colHeader
        .eq(index)
        .addClass('active');
    $.extend(CON.queryObj, CON.statusMap[index]);
    CON.getCommittalByStatus(CON.queryObj, CON.renderList, true);
    $('.bottom-line').slideUp();
};

CON.renderItem = function (domItem, dataObj) {
    if (!domItem || (typeof dataObj === 'undefined'
        ? 'undefined'
        : _typeof(dataObj)) != 'object') 
        return;
    var itemStr = JSON.stringify(dataObj);
    var _html = '<li class="project-item">\n            <div class="project-info">\n             ' +
            '   <div class="project-base-info">\n                    <div class="col-item col' +
            '-1">' + dataObj.project_name + '</div>\n                    <div class="col-item col-2 industry">' + dataObj.created_at + '</div>\n                    <div class="col-item col-3 address">\u6B63\u5728' +
            '\u6267\u884C</div>\n                    <div class="col-item col-4 delete">\n   ' +
            '                 ' + (dataObj.has_project == 1
        ? '<div class="handle-hover">-' +
            '</div>'
        : '') + '\n                        ' + (dataObj.has_project == 0
        ? '<div class="handle-delete" data-info=\'' + itemStr + '\'> \u7F16\u8F91</div>'
        : '') + '\n                    </div>\n                </div>\n            </div>\n      ' +
            '  </li>';
    domItem.replaceWith(_html);
};

CON.showMessage = function (status, times) {
    if (status == -1) {
        // $('#statusMessage').text('（失败委托我们会返还委托次数）');
        $('#statusMessage').text('');
    } else if (status == 1) {
        $('#statusMessage').text('');
    } else {
        $('#statusMessage').text("");
        // $('#statusMessage') .replaceWith(` <span id="statusMessage"> （本周剩余委托
        // <span id="lastTime">${times}</span>  次，次数不叠加累计） </span> `);
    }
};

CON.renderList = function (list, bClear) {
    var i = 0,
        l = list.length;
    var _html = '';
    var $listDom = $('#listDom');
    if (bClear) {
        $listDom.empty();
    }
    if (l == 0) {
        CON.showEmpty(true);
    } else {
        CON.showEmpty(false);
    }
    var bStatusing = CON.queryObj.status === 0;
    if (bStatusing) {
        for (; i < l; i++) {
            var item = list[i];
            var itemStr = JSON.stringify(item);
            _html += '\n        <li class="project-item">\n            <div class="project-info">\n   ' +
                    '             <div class="project-base-info">\n                    <div class="co' +
                    'l-item col-1">' + item.project_name + '</div>\n                    <div class="col-item col-2 industry">' + item.created_at + '</div>\n                    <div class="col-item col-3 address">\u6B63\u5728' +
                    '\u6267\u884C</div>\n                    <div class="col-item col-4 delete">\n   ' +
                    '                 ' + (item.has_project == 1
                ? '<div class="handle-hover">-' +
                    '</div>'
                : '') + '\n                        ' + (item.has_project == 0
                ? '<div class="handle-delete" data-info=\'' + itemStr + '\'> \u7F16\u8F91</div>'
                : '') + '\n                    </div>\n                </div>\n            </div>\n      ' +
                    '  </li>\n        ';
        }
    } else {
        for (; i < l; i++) {
            var item = list[i];
            _html += '\n        <li class="project-item">\n            <div class="project-info">\n   ' +
                    '             <div class="project-base-info">\n                    <div class="co' +
                    'l-item col-1">' + item.project_name + '</div>\n                    <div class="col-item col-2 industry">' + item.created_at + '</div>\n                    <div class="col-item col-3 address">' + item.end_time + '</div>\n                    <div class="col-item col-4 status">' + (item.committal_status == 1
                ? '委托成功'
                : '委托失败') + '</div>\n                </div>\n            </div>\n        </li>\n        ';
        }
    }

    $listDom.append(_html);
};

CON.showEmpty = function (bShow) {
    bShow
        ? $('#emptyData').show()
        : $('#emptyData').hide();
};
// global.CON = CON;
// })(undefined);